import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionFigmaDesignreview = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"type": "page",
			"properties": {
				"title": [
					[
						"Дизайн–ревью"
					]
				]
			},
			"content": [
				"5edbe12a-cbc3-4d32-b973-cff04fae48ba",
				"559198f7-fedd-483e-8e31-f349747e8212",
				"8990ef30-cd8b-48b2-8ef6-67f74a468db5",
				"90e5835f-3116-40dc-a551-47b84f40c7a5",
				"dbd33b1a-cd00-4415-b6d6-fc9109d82454",
				"8eab8e6e-1c45-4013-a077-a055b8afed4f",
				"3d32466b-a0d8-44d1-a931-538b9ac9110e",
				"30fc251c-8927-4ccb-80ea-530da030533d",
				"d6470cad-b17f-4d18-a40c-25c787e85f41",
				"ba021827-3e68-4404-9815-c3ec200779c6",
				"e7f588d2-5083-4a7f-8a74-11af2c9b07b9",
				"f931490a-c691-4d64-ab3a-0fc6c851cf24",
				"a0c31411-8660-4363-974c-e404613a038d",
				"aa39c4ba-5ef3-48b9-b10a-f98d17d5358c",
				"c392d15e-0eaa-466b-b890-9e7d8f849dce",
				"3fd9f825-6710-41d3-a56a-2b23dd7a06bf",
				"da47ec8b-af61-43cc-a731-070aa5dd64ba",
				"f94a6be1-5c19-4ef8-9dfa-80eabb60ed08",
				"58f76acb-434a-47bd-b0f3-26b44b5be60d",
				"dffdbd52-dfe6-4cc1-883a-58c0660df150",
				"7a7ea295-45c8-4dac-a1ae-fc77e78d9dee",
				"d34f0b31-3255-4afd-b9c2-18db7c5768b6",
				"5b2de928-7ed4-454b-a4e2-524905c7ccab",
				"ed79377c-0229-4503-a7d2-b2eaf67129eb",
				"58282765-c8e8-49d3-8306-3fb496d3c734",
				"03709cd7-1662-47ea-8c15-60489149aa52",
				"f83f1f03-347a-40f6-b003-320553e24b8e",
				"8c296e41-ce64-4b0c-8de9-8e1cceadccc1",
				"cc45f5b0-ce67-4eef-abdd-69ec74b06c5a",
				"760ab40b-86a3-4a90-a789-35afa58d15f7",
				"aa2657f2-6e9f-403c-ba68-7b417243f1cb",
				"dac76bd3-f333-4243-86ff-4467c8eee70f",
				"4641583e-c638-479f-831d-fc0d203e90cb",
				"43249742-2e8e-44f1-a7dc-9c471327398e",
				"a181053d-a22c-42fe-b08d-ea7048b9e1fc",
				"51675160-f7bc-4b56-9558-b0f132852204",
				"b6147c04-e0f4-43a2-a4fe-9383f1b5eed8",
				"beeae2dd-a873-4489-b261-02a99c60f4cd",
				"4cbdfaad-d9d4-462a-93bf-2d30b87c1a6b",
				"4058e1a5-1f41-4e1a-a3e4-acfcde7a2113",
				"ad7a29bc-4c24-46d7-bbb2-210ee10aee70",
				"f67655f4-2a06-4b27-9f3b-00df58812088",
				"d36eae70-4839-4b5c-8c89-08c038023d75"
			],
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5edbe12a-cbc3-4d32-b973-cff04fae48ba",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/figma/designreview\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "84034bb7-9390-490b-bea7-e09c7d852c89",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "559198f7-fedd-483e-8e31-f349747e8212",
			"type": "text",
			"properties": {
				"title": [
					[
						"После того как разработчик реализовал ваши макеты, для всех задач существует этап дизайн–ревью. На этом этапе мы смотрим насколько точно реализован интерфейс, есть ли расхождения во флоу и тестируем на разных устройствах."
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8990ef30-cd8b-48b2-8ef6-67f74a468db5",
			"type": "header",
			"properties": {
				"title": [
					[
						"Как провести дизайн–ревью"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "90e5835f-3116-40dc-a551-47b84f40c7a5",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"1. Получение материалов"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dbd33b1a-cd00-4415-b6d6-fc9109d82454",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для начала нужно получить от "
					],
					[
						"разработчика скриншоты",
						[
							[
								"m",
								"4ef23c0d-948c-4843-a906-ea28395105c9"
							]
						]
					],
					[
						" или готовую сборку с фичей."
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8eab8e6e-1c45-4013-a077-a055b8afed4f",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Нужны экраны в темной и светлой темах интерфейса"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3d32466b-a0d8-44d1-a931-538b9ac9110e",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Для "
					],
					[
						"устройств Android",
						[
							[
								"m",
								"6dd6d2f6-185c-4d03-9f0d-d8a009f9f936"
							]
						]
					],
					[
						" используем ширину как в макетах, чаще всего 360 dp"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "30fc251c-8927-4ccb-80ea-530da030533d",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Для iOS смотрим экраны на ширине 375 dp"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d6470cad-b17f-4d18-a40c-25c787e85f41",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Если фича крупная и полностью новая нужно проверить ее на iPad"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ba021827-3e68-4404-9815-c3ec200779c6",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Мобильный web можно проверять в браузере используя настройки инспектора"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e7f588d2-5083-4a7f-8a74-11af2c9b07b9",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"В скриншотах или скринкастах должны использоваться понятные "
					],
					[
						"названия",
						[
							[
								"m",
								"d12da9e4-9bef-4f43-86ff-507fdd03d257"
							]
						]
					],
					[
						", фото и другие элементы. Лучше стараться заполнять тестовые сборки данными приближенными к реальным. "
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f931490a-c691-4d64-ab3a-0fc6c851cf24",
			"type": "image",
			"properties": {
				"size": [
					[
						"2016.6KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d6f9364b-bdfa-4fa3-8298-068d1ebba0d6/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 2700,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d6f9364b-bdfa-4fa3-8298-068d1ebba0d6/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.8822222222222222,
				"block_preserve_scale": true
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"file_ids": [
				"d6f9364b-bdfa-4fa3-8298-068d1ebba0d6"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/f931490a-c691-4d64-ab3a-0fc6c851cf24.png"
		},
		{
			"id": "a0c31411-8660-4363-974c-e404613a038d",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"2. Проверка функционала"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "aa39c4ba-5ef3-48b9-b10a-f98d17d5358c",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Пройти весь основной разрабатываемый сценарий"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c392d15e-0eaa-466b-b890-9e7d8f849dce",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Интерфейс работает плавно, без скачков и подтормаживаний"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3fd9f825-6710-41d3-a56a-2b23dd7a06bf",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Интерактивные элементы для веб имеют "
					],
					[
						"эффект наведения",
						[
							[
								"m",
								"d2a107a6-0be5-4db6-8bbe-403fcceeaef5"
							]
						]
					],
					[
						" "
					],
					[
						"и нажатия",
						[
							[
								"m",
								"21429d4a-5e4a-4c1c-8c66-1ca26e46e7e0"
							]
						]
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "da47ec8b-af61-43cc-a731-070aa5dd64ba",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Ошибки ввода данных отображаются корректно"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f94a6be1-5c19-4ef8-9dfa-80eabb60ed08",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Проверить пустые состояния экранов и экраны загрузки"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "58f76acb-434a-47bd-b0f3-26b44b5be60d",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"3. Тест скриншотов"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dffdbd52-dfe6-4cc1-883a-58c0660df150",
			"type": "text",
			"properties": {
				"title": [
					[
						"Сделать скриншоты для тестов и разместить на отдельной странице Figma файле с макетом."
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7a7ea295-45c8-4dac-a1ae-fc77e78d9dee",
			"type": "text",
			"properties": {
				"title": [
					[
						"Сравнить наложением",
						[
							[
								"m",
								"686eb98b-148a-44f0-ac43-8adf53b2a531"
							]
						]
					],
					[
						" макеты и подготовленные "
					],
					[
						"скриншоты",
						[
							[
								"m",
								"b7fd1a2f-4901-4838-846d-cbd051086ec7"
							]
						]
					],
					[
						". Если размеры не совпадают, можно запросить у разработчика снимки экрана под разные стандартные разрешения."
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d34f0b31-3255-4afd-b9c2-18db7c5768b6",
			"type": "image",
			"properties": {
				"size": [
					[
						"379.6KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3be0da5b-2337-412e-89d0-d90759757091/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3be0da5b-2337-412e-89d0-d90759757091/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.4115853658536585,
				"block_preserve_scale": true
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"file_ids": [
				"3be0da5b-2337-412e-89d0-d90759757091"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/d34f0b31-3255-4afd-b9c2-18db7c5768b6.png"
		},
		{
			"id": "5b2de928-7ed4-454b-a4e2-524905c7ccab",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"4. Проверка отступов, размеров и стилей"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "58f76acb-434a-47bd-b0f3-26b44b5be60d",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ed79377c-0229-4503-a7d2-b2eaf67129eb",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Размеры должны быть кратны 4, в частных случаях 2"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "58282765-c8e8-49d3-8306-3fb496d3c734",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Отступы в базовых компонентах на токенах"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "03709cd7-1662-47ea-8c15-60489149aa52",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Стили типографики соответствуют общей библиотеке продукта"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f83f1f03-347a-40f6-b003-320553e24b8e",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"5. Выписать критичные замечания"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5b2de928-7ed4-454b-a4e2-524905c7ccab",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8c296e41-ce64-4b0c-8de9-8e1cceadccc1",
			"type": "text",
			"properties": {
				"title": [
					[
						"Рекомендуем использовать шаблон фигма для написания комментариев "
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cc45f5b0-ce67-4eef-abdd-69ec74b06c5a",
			"type": "image",
			"properties": {
				"size": [
					[
						"463.6KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/35a6a21c-1611-40c4-8f47-bde65ebb3178/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/35a6a21c-1611-40c4-8f47-bde65ebb3178/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5944444444444444,
				"block_preserve_scale": true
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"file_ids": [
				"35a6a21c-1611-40c4-8f47-bde65ebb3178"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/cc45f5b0-ce67-4eef-abdd-69ec74b06c5a.png"
		},
		{
			"id": "760ab40b-86a3-4a90-a789-35afa58d15f7",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"6. Передать замечания разработчику"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f83f1f03-347a-40f6-b003-320553e24b8e",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "aa2657f2-6e9f-403c-ba68-7b417243f1cb",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Дать ссылку на страницу в Figma"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dac76bd3-f333-4243-86ff-4467c8eee70f",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Написать комментарий в задаче Jira"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4641583e-c638-479f-831d-fc0d203e90cb",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Проверить повторно после исправления"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "43249742-2e8e-44f1-a7dc-9c471327398e",
			"type": "header",
			"properties": {
				"title": [
					[
						"Критичные замечания"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a181053d-a22c-42fe-b08d-ea7048b9e1fc",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"При наложении скриншотов видно поехавшие отступы или разхождения в типографике"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "51675160-f7bc-4b56-9558-b0f132852204",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Наличие элементов которые не предусмотрены макетом, логикой"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b6147c04-e0f4-43a2-a4fe-9383f1b5eed8",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Поехавшие базовые линии в интерфейсах"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "beeae2dd-a873-4489-b261-02a99c60f4cd",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Использование кастомных цветов не соответствующих дизайн-системе"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4cbdfaad-d9d4-462a-93bf-2d30b87c1a6b",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Анимация не плавная и подтормаживает"
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4058e1a5-1f41-4e1a-a3e4-acfcde7a2113",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Отсутствуют скелетоны при загрузке эк"
					],
					[
						"рана",
						[
							[
								"m",
								"7953518f-794d-41a2-97f8-9484cce57485"
							]
						]
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ad7a29bc-4c24-46d7-bbb2-210ee10aee70",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Краевые кейсы не отрабатываются интерфейсом. Например отсутствует индикатор ошибки или большое количество символов в поле ломает интерфейс. "
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f67655f4-2a06-4b27-9f3b-00df58812088",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Если при наложении макета на экран есть небольшие разногласия, но они никак не влияют на качество интерфейса и не нарушают задумки дизайнера, разрешается не сообщать о таких ошибках."
					]
				]
			},
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d36eae70-4839-4b5c-8c89-08c038023d75",
			"type": "text",
			"parent_id": "311c23ba-4ac6-48a0-bf3b-de8b115c363f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Как провести дизайн–ревью",
			"id": "8990ef30-cd8b-48b2-8ef6-67f74a468db5"
		},
		{
			"title": "Критичные замечания",
			"id": "43249742-2e8e-44f1-a7dc-9c471327398e"
		}
	]
}} />
);

export default NotionFigmaDesignreview;
